export default __webpack_public_path__ + "static/media/Dhaka-metro.47412578.png";